import { useState } from 'react';
import { Meta, useLazyWorkplaceMetaQuery } from '../../../graphql/graphql';
import useMeta from '../../Meta/Hooks/useMeta';
import { useEffectAsync } from '../../../helpers';
import useLoading from '../../Base/Hooks/useLoading';

export default function useWorkplaceMeta({
	workplaceId,
}: {
	workplaceId: string;
}) {
	const { isLoading, setIsLoading } = useLoading(true);
	const [meta, setMeta] = useState<Record<string, any>>({});
	const { getMetaAsObject } = useMeta();
	const [getWorkplaceMeta] = useLazyWorkplaceMetaQuery();

	const handleLoadMeta = async () => {
		const workplaceMetaData = await getWorkplaceMeta({ id: workplaceId });
		if (workplaceMetaData?.data?.workplace?.meta) {
			const transformedMeta = getMetaAsObject(
				workplaceMetaData?.data?.workplace?.meta as Meta[],
			);
			setMeta(transformedMeta);
		}
		setIsLoading(false);
	};

	useEffectAsync(async () => {
		await handleLoadMeta();
	}, []);

	return {
		workplaceMeta: meta,
		reFetchWorkplaceMeta: handleLoadMeta,
		isLoadingWorkplaceMeta: isLoading,
	};
}
